"use client";

import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Loader2, Trash2 } from "lucide-react";

const UpdateSubAccount = ({
  openUpdate,
  setOpenUpdate,
  onUpdate,
  onFunds,
  setSubAccountName,
  subAccountName,
  loading,
}) => {
  const handleUpdate = () => {
    onUpdate?.();
  };
  const handleFunds = () => {
    onFunds?.();
  };
  return (
    <Dialog open={openUpdate} onOpenChange={setOpenUpdate}>
      <DialogContent className="max-w-md p-6 rounded-lg shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-[24px] text-[#57249C] font-semibold mt-5 mb-3">
            Update new sub account
          </DialogTitle>
        </DialogHeader>
        <div className="mb-5">
          <div className="relative w-full">
            <p className="text-[14px] text-[#6D6584] font-normal mb-2">
              Sub account name
            </p>
            <input
              type="text"
              placeholder="Sub account name"
              value={subAccountName}
              onChange={(e) => setSubAccountName(e.target.value)}
              className="border-[1px] rounded-[10px] border-[#CECBD7] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] text-[14px] font-normal px-5 py-4"
            />
          </div>
        </div>
        <div className="grid grid-cols-2">
          <div className="pr-2">
            <DialogClose className="w-full">
              <Button className="text-[#6D6584] font-semibold text-[14px] rounded-full bg-transparent border-[1px] hover:opacity-90 w-full py-5">
                Cancel
              </Button>
            </DialogClose>
          </div>
          <div className="pl-2">
            <Button
              className="text-sm font-semibold text-[#FFFFFF] rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90 w-full py-5"
              onClick={handleUpdate}
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin w-4 h-4" />
                  <span className="ml-2">Updating...</span>
                </>
              ) : (
                "Update"
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateSubAccount;
